exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dependencies-list[data-v-5eb95e1a]{display:grid;grid-template-columns:repeat(2,1fr);gap:.75rem}.email-suggestion[data-v-5eb95e1a]{margin-top:-.5rem;color:#7a7a7a}.email-suggestion .email-suggestion__link[data-v-5eb95e1a]{color:#7957d5;font-weight:600;cursor:pointer;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5eb95e1a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cultura/components/Collaborator/CreateCollaboratorModal.vue
// module id = 1509
// module chunks = 2